import React, { useState, useEffect, forwardRef } from 'react';
import { idbStorage } from '../lib/idbStorage';

/**
 * MediaRender
 * A drop-in replacement for <img> and <video> that natively supports 
 * rendering blobs stored in IndexedDB (URL starting with "idb://").
 */
const MediaRender = forwardRef(({ src, type, className, ...props }, ref) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let urlToRevoke = null;

    const loadMedia = async () => {
      if (!src) return;

      if (src.startsWith('idb://')) {
        try {
          const blob = await idbStorage.getMedia(src);
          if (blob && active) {
            urlToRevoke = URL.createObjectURL(blob);
            setBlobUrl(urlToRevoke);
          }
        } catch (e) {
          console.error("Failed to load local media:", e);
        }
      } else {
        if (active) {
          setBlobUrl(src);
        }
      }
    };

    loadMedia();

    return () => {
      active = false;
      if (urlToRevoke) {
        URL.revokeObjectURL(urlToRevoke);
      }
    };
  }, [src]);

  if (!blobUrl) {
    return <div className={`bg-white/5 animate-pulse ${className}`} />;
  }

  if (type === 'video') {
    return <video ref={ref} src={blobUrl} className={className} {...props} />;
  }

  return <img ref={ref} src={blobUrl} className={className} {...props} />;
});

export default MediaRender;
